import { getServiceUrl } from '../api.config';
import { ApiClientOptions } from '../types/api';
import ApiClient from '../utils/ApiClient';
import checkNot from '../utils/checkNot';
import qs from '../utils/query';

export default class ReferentialApi extends ApiClient {
  public static PATH() {
    return {
      COMMON_UNITS: 'commonunits',
      DIMENSIONS: 'dimensions',
      LANGUAGES: 'languages',
      MEASUREMENT_PRECISIONS: 'measurementprecisions',
      NUTRIENTS: 'nutrients',
      PREPARATION_STATES: 'preparationstates',
    };
  }

  public constructor(options?: ApiClientOptions) {
    super(getServiceUrl('core'), options);
  }

  public ReferentialList(queries?: any) {
    const query = `/core/v3/referentials${qs.stringify(queries, true)}`;
    return this.get(query);
  }

  public ReferentialGet(path: string, id: string | number, queries?: any) {
    const query = `/core/v3/referentials/${path}/${id}${qs.stringify(
      queries,
      true,
    )}`;
    return this.get(query);
  }

  public ReferentialCreate(name: string) {
    const query = '/core/v3/referentials';
    return this.post(query, { name });
  }

  public ReferentialGetList(path: string, queries?: any) {
    const query = `/core/v3/referentials/${path}${qs.stringify(queries, true)}`;
    return this.get(query);
  }

  public ReferentialGetListMultiple(
    referentialNames: string[],
    silent: boolean = false,
    queries: any = {},
  ) {
    const query = `/core/v3/referentials/multiple${qs.stringify(
      queries,
      true,
    )}`;
    return this.post(query, {
      referential_names: referentialNames,
      silent,
    });
  }

  public ReferentialGetCategories(path: string, queries: any = {}) {
    const query = `/core/v3/referentials/${path}/categories`;

    let parameters = '?alk=1';
    if (checkNot(queries.kindId, ['undefined', 'null', 'empty'])) {
      parameters += `&kind_id=${queries.kindId}`;
    }
    if (checkNot(queries.targetMarkets, ['undefined', 'null', 'empty'])) {
      parameters += `&targetmarkets=${queries.targetMarkets}`;
    }

    return this.get(query, parameters);
  }

  public downloadAll(queries: any, data: any) {
    const query = '/core/v3/referentials/download';
    return this.getBlob(query, qs.stringify(queries, true), data, true);
  }

  public getListColumnReferentials({ cache = true }: any = {}) {
    const query = '/core/v3/referentials/listcolumns';
    const params: any = {};
    return this.get(query, qs.stringify(params, true), cache);
  }

  public getListReportingReferentials({ cache = true }: any = {}) {
    const query = '/core/v3/referentials/ReportingDashboard';
    const params: any = {};
    return this.get(query, qs.stringify(params, true), cache);
  }

  public getListReportingConfigReferentials({ cache = true }: any = {}) {
    const query = '/core/v3/referentials/ReportingConfig';
    const params: any = {};
    return this.get(query, qs.stringify(params, true), cache);
  }
}
